import { ActivityFeed } from 'app/components/activity-feed';

/**
 * Activity Center — the tenant's personal feed of their records across Requests, Bookings, Events,
 * and Visitors, each deeplinking back into its source module. The feed owns the full sticky header
 * (title + segmented + filter rail); the card list scrolls beneath it (VIS-1530).
 */
export const MiniappActivityCenterPage = (): JSX.Element => (
  <div data-testid="miniapp-activity-center" className="h-full">
    <ActivityFeed />
  </div>
);
